import createSvgIcon from "./utils/create_icon"

const ArrowLeftLarge = createSvgIcon(<path d="M9.707 5.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0z" clipRule="evenodd" fill="currentColor" fillRule="evenodd" />, "ArrowLeftLarge")
export default ArrowLeftLarge
